
<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
      <div
        v-if="loader"
        class="fixed inset-0 flex items-center justify-center bg-black  z-50"
      >
        <img
          src="@/assets/imgs/tuin_loader.gif"
          alt="cargando..."
          class=" w-[500px]"
        >
      </div>
      <div class="flex">
        <ToastAlert
          :is-active="toastAlert"
          :type="typeMsg"
          :message="msg"
        />
      </div>
      <div class="row my-3">
        <div class="w-full ">
          <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center w-full">
            <!-- Breadcrumb -->
            <nav class="w-full sm:w-3/4" aria-label="Breadcrumb">
              <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                <li class="inline-flex items-center">
                  <a href="/properties" class="inline-flex items-center text-sm font-medium text-custom_gray hover:text-tuin-100 uppercase">
                    MIS PROPIEDADES
                  </a>
                </li>
                <li aria-current="page">
                  <div class="flex items-center">
                    <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 9 4-4-4-4" />
                    </svg>
                    <a href="#" class="ms-1 text-sm font-medium text-custom_gray uppercase">
                      {{ property.property_name }}
                    </a>
                  </div>
                </li>
              </ol>
            </nav>
            <!-- Eliminar/Activar/Desactivar -->
            <div class="only-dest w-full sm:w-1/4 mt-4 lg:mt-0 lg:text-right flex justify-end text-custom_gray text-sm font-medium">
              <select
                v-if="!property.is_associated" 
                v-model="selectedStatus"
                @change="changePropertyStatus"
                :disabled="property.status_id === null"
                :class="[
                  'bg-white border mr-4 border-[#DEE2E6] text-sm rounded-md focus:ring-tuin-100 focus:border-tuin-100 w-auto h-[42px]',
                  property.status_id === null ? 'text-gray-400 cursor-not-allowed' : 'text-gray-500'
                ]"
              >
                <option 
                  v-for="status in statusOptions" 
                  :key="status.value" 
                  :value="status.value"
                  class="text-gray-900"
                >
                  {{ property.status_id === null ? 'Borrador' : status.name }}
                </option>
              </select>
              <button v-if="!property.is_associated" @click="openDeleteModal(proeprtyId)" class="hover:underline hover:text-tuin_hover">Eliminar</button>
              <button v-if="property.is_associated" @click="askRemoveProperty(proeprtyId)" class="hover:underline hover:text-tuin_hover">Retirar</button>
            </div>
          </div>
        </div>
        <!--New Design-->
        <div class="flex flex-wrap">
          <!-- Botones móviles - arriba de todo -->
          <div class="only-mob w-full mb-2">
            <div class="flex justify-end">
              <button 
                v-if="!property.is_associated" 
                @click="openDeleteModal(proeprtyId)" 
                class="text-custom_gray font-medium text-sm hover:underline hover:text-tuin_hover"
              >
                Eliminar
              </button>
              <button 
                v-if="property.is_associated" 
                @click="askRemoveProperty(proeprtyId)" 
                class="text-custom_gray font-medium text-sm hover:underline hover:text-tuin_hover"
              >
                Retirar
              </button>
            </div>
          </div>
          <div class="sm:w-2/5 w-full">
            <!--New Gallery-->
            <GalleryComponent :images="pictures" />
          </div>
          <div class="only-dest sm:w-3/5 pl-8">
            <div class="flex items-center justify-between">
              <div class="w-full mb-4">
                <CardMovementComponent :property="property" />
              </div>
              <!-- Botones de acciones -->
              <div class="flex space-x-2">
                <button
                  v-if="!property.is_associated" 
                  class="group flex items-center rounded-full border hover:bg-custom_gray border-custom_gray p-1"
                  @click="goToEdit('edit', proeprtyId)" 
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M16.732 3.73196C17.2009 3.26306 17.8369 2.99963 18.5 2.99963C19.1631 2.99963 19.7991 3.26306 20.268 3.73196C20.7369 4.20087 21.0003 4.83683 21.0003 5.49996C21.0003 6.16309 20.7369 6.79906 20.268 7.26796L18.768 8.76796L6.5 21.036H3V17.464L15.232 5.23196L16.732 3.73196Z" class="fill-white group-hover:fill-custom_gray"/>
                    <path d="M15.232 5.23196L18.768 8.76796M16.732 3.73196C17.2009 3.26306 17.8369 2.99963 18.5 2.99963C19.1631 2.99963 19.7991 3.26306 20.268 3.73196C20.7369 4.20087 21.0003 4.83683 21.0003 5.49996C21.0003 6.16309 20.7369 6.79906 20.268 7.26796L6.5 21.036H3V17.464L16.732 3.73196Z" class="stroke-custom_gray group-hover:stroke-white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>

                <button
                  v-if="property.status_id != null" 
                  class="group flex items-center rounded-full border hover:bg-tuinColor/90 hover:border-tuin_hover border-tuin-100 p-1" 
                  @click="callActionLog(proeprtyId, 7, 'Usuario hizó clic en el botón de compartir propiedad desde Asesores'); showShareModal = true"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8.6831 13.3421C8.8851 12.9381 8.9991 12.4821 8.9991 12.0001C8.9991 11.5181 8.8851 11.0621 8.6831 10.6581M8.6831 13.3421C8.38081 13.9465 7.88331 14.4311 7.2712 14.7175C6.65909 15.0038 5.96823 15.0751 5.31055 14.9198C4.65286 14.7645 4.06687 14.3917 3.64752 13.8618C3.22816 13.3319 3 12.6759 3 12.0001C3 11.3243 3.22816 10.6684 3.64752 10.1384C4.06687 9.60853 4.65286 9.23572 5.31055 9.08041C5.96823 8.92511 6.65909 8.9964 7.2712 9.28275C7.88331 9.5691 8.38081 10.0537 8.6831 10.6581M8.6831 13.3421L15.3151 16.6581M8.6831 10.6581L15.3151 7.34211M15.3151 16.6581C14.9592 17.37 14.9006 18.194 15.1523 18.9491C15.404 19.7041 15.9453 20.3282 16.6571 20.6841C17.3689 21.04 18.193 21.0986 18.948 20.8469C19.7031 20.5953 20.3272 20.054 20.6831 19.3421C21.039 18.6303 21.0976 17.8062 20.8459 17.0512C20.5942 16.2962 20.0529 15.672 19.3411 15.3161C18.9886 15.1399 18.6049 15.0348 18.2118 15.0069C17.8187 14.9789 17.424 15.0287 17.0502 15.1533C16.2951 15.405 15.671 15.9463 15.3151 16.6581ZM15.3151 7.34211C15.4913 7.69452 15.7353 8.00876 16.0329 8.26689C16.3306 8.52503 16.6762 8.722 17.05 8.84657C17.4238 8.97114 17.8185 9.02087 18.2115 8.99291C18.6045 8.96495 18.9882 8.85985 19.3406 8.68361C19.693 8.50738 20.0072 8.26346 20.2654 7.96578C20.5235 7.66811 20.7205 7.3225 20.8451 6.9487C20.9696 6.5749 21.0194 6.18022 20.9914 5.7872C20.9634 5.39418 20.8583 5.01052 20.6821 4.65811C20.3262 3.94641 19.7021 3.40524 18.9472 3.15366C18.1923 2.90208 17.3683 2.96069 16.6566 3.31661C15.9449 3.67253 15.4037 4.2966 15.1521 5.05153C14.9006 5.80646 14.9592 6.63041 15.3151 7.34211Z" class="stroke-[#FF4265] group-hover:stroke-white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
            <!-- Nombre -->
            <h1 class="text-left text-xl md:text-xl font-medium md:mt-2">
              {{ property.property_name }}
            </h1>
            <!-- Dirección -->
            <p class="flex items-center text-gray-400 text-sm font-medium">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <path d="M8.00048 10.2414C7.47306 10.2414 6.95749 10.085 6.51896 9.79202C6.08043 9.49901 5.73863 9.08253 5.5368 8.59526C5.33496 8.10799 5.28216 7.57181 5.38505 7.05453C5.48794 6.53725 5.74192 6.06209 6.11486 5.68915C6.4878 5.31621 6.96295 5.06224 7.48024 4.95934C7.99752 4.85645 8.5337 4.90926 9.02097 5.11109C9.50824 5.31293 9.92471 5.65472 10.2177 6.09325C10.5107 6.53178 10.6671 7.04735 10.6671 7.57477C10.6671 8.28201 10.3862 8.96029 9.8861 9.46039C9.386 9.96049 8.70772 10.2414 8.00048 10.2414ZM8.00048 6.24144C7.73677 6.24144 7.47898 6.31964 7.25972 6.46614C7.04045 6.61265 6.86955 6.82089 6.76864 7.06453C6.66772 7.30816 6.64132 7.57625 6.69276 7.83489C6.74421 8.09353 6.8712 8.33111 7.05767 8.51758C7.24414 8.70405 7.48172 8.83104 7.74036 8.88248C7.999 8.93393 8.26709 8.90753 8.51072 8.80661C8.75436 8.70569 8.96259 8.5348 9.1091 8.31553C9.25561 8.09627 9.33381 7.83848 9.33381 7.57477C9.33381 7.22115 9.19334 6.88201 8.94329 6.63196C8.69324 6.38191 8.3541 6.24144 8.00048 6.24144Z" fill="#737373"/>
                <path d="M8.00048 15.5748C7.90205 15.5747 7.80485 15.5529 7.71586 15.5108C7.62688 15.4687 7.54831 15.4075 7.48581 15.3314L3.98914 11.0821C3.92248 11.0074 3.84648 10.9141 3.77181 10.8154L3.69181 10.7181C3.66076 10.6805 3.63393 10.6396 3.61181 10.5961C3.0627 9.79989 2.74044 8.86933 2.67953 7.90404C2.61863 6.93875 2.82136 5.97507 3.26605 5.11615C3.71073 4.25723 4.38061 3.5354 5.204 3.02793C6.02738 2.52045 6.97327 2.24644 7.94041 2.23522C8.90756 2.224 9.85955 2.476 10.6945 2.96423C11.5294 3.45247 12.2159 4.15856 12.6804 5.00694C13.1448 5.85531 13.3699 6.81403 13.3314 7.78047C13.2929 8.74691 12.9923 9.6847 12.4618 10.4934C12.44 10.5393 12.4127 10.5823 12.3805 10.6214L12.2958 10.7248C12.1766 10.8878 12.048 11.0436 11.9105 11.1914L8.51581 15.3281C8.45356 15.4048 8.37503 15.4668 8.28591 15.5094C8.19678 15.5521 8.09929 15.5744 8.00048 15.5748ZM4.78381 9.94944L4.81514 9.98744C4.88181 10.0774 4.94381 10.1488 5.00514 10.2181L8.00048 13.8581L10.9058 10.3194C11.0252 10.1909 11.1365 10.0551 11.2391 9.91277L11.2891 9.8521L11.3065 9.82477C11.7188 9.22014 11.9574 8.51396 11.9962 7.78313C12.035 7.0523 11.8726 6.32482 11.5266 5.67992C11.1806 5.03501 10.6643 4.4974 10.0339 4.1256C9.4035 3.75381 8.68319 3.56209 7.95138 3.57133C7.21958 3.58056 6.50433 3.79039 5.88352 4.17797C5.26272 4.56555 4.76014 5.11603 4.43052 5.76946C4.1009 6.42289 3.95686 7.15423 4.0141 7.88385C4.07134 8.61347 4.32766 9.3134 4.75514 9.90744C4.76581 9.92166 4.77537 9.93566 4.78381 9.94944Z" fill="#737373"/>
              </svg>
              {{ property.address }}
            </p>

            <!-- Precio -->
            <div class="text-black text-3xl mt-4">
              <!-- Valor de venta -->
              <div class="flex flex-wrap">
              <!-- Valor de venta -->
              <div
                v-if="property.type_movement_id == 1 || property.type_movement_id == 3 || property.type_movement_id == 5"
                class="w-full md:w-1/2 text-left md:text-left"
              >
                <span class="block text-base font-normal">
                  <template v-if="property.type_movement_id === 3">Venta</template>
                  <template v-else>{{ property.property_movement }}</template>
                </span>
                <span class="block text-3xl font-bold">
                  {{ property.property_value }}
                  <span class="text-xl font-semibold">{{ property.currency_code || property.currency }}</span>
                </span>
                <div class="text-base font-normal text-gray-900" v-if="property.has_commission_sale">Comisión {{ property.commission_sale_value }} %</div>
              </div>

              <!-- Valor de renta -->
              <div
                v-if="property.type_movement_id == 2 || property.type_movement_id == 3 || property.type_movement_id == 4"
                class="w-full md:w-1/2 text-left md:text-left"
              >
                <span class="block text-base font-normal">
                  <template v-if="property.type_movement_id === 3">Renta</template>
                  <template v-else>{{ property.property_movement }}</template>
                </span>
                <span class="block text-3xl font-bold">
                  {{ property.rent_value }}
                  <span class="text-xl font-semibold">{{ property.currency_code || property.currency }}</span>
                </span>
                <div class="text-base font-normal text-gray-900" v-if="property.has_commission_rent">Comisión {{ property.commission_rent_value }} %</div>
              </div>
            </div>
            <!-- Mantenimiento -->
              <div
                v-show="property.include_maintenance == 0 && property.maintenance_value != '$0'"
                class="text-base text-black font-medium mt-4"
              >
                <span class="block font-semibold">Mantenimiento</span>
                <span class="block font-bold text-lg">
                  {{ property.maintenance_value }}
                  <span class="text-base font-semibold">{{ property.currency }}</span>
                </span>
              </div>
              <div
                v-show="!property.include_maintenance == 0"
                class="text-base text-black font-medium mt-4"
              >
                <span class="block font-semibold">Mantenimiento incluido</span>
              </div>
            </div>
            <!-- Caracteristicas section -->
            <div id="caracteristicas" class="flex flex-wrap">
              <CardCharactersComponent 
                :list="characters_list.value"
                :property="property" 
              />
            </div>
          </div>
        </div>
        <div class="only-mob">
          <div class="flex flex-row w-full justify-between items-center mt-4">
            <!-- Texto a la izquierda -->
            <div class="w-1/2">
              <select
                v-if="!property.is_associated" 
                v-model="selectedStatus"
                @change="changePropertyStatus"
                :disabled="property.status_id === null"
                :class="[
                  'bg-white border mr-4 border-[#DEE2E6] text-sm rounded-md focus:ring-tuin-100 focus:border-tuin-100 w-full h-[42px]',
                  property.status_id === null ? 'text-gray-400 cursor-not-allowed' : 'text-gray-500'
                ]"
              >
                <option 
                  v-for="status in statusOptions" 
                  :key="status.value" 
                  :value="status.value"
                  class="text-gray-900"
                >
                  {{ property.status_id === null ? 'Borrador' : status.name }}
                </option>
              </select>
            </div>
            <!-- Botón a la derecha -->
            <div class="flex justify-end items-center">
              <div class="flex space-x-2">
                <button 
                  class="group flex items-center rounded-full border hover:bg-tuin_hover hover:border-tuin_hover border-tuin-100 p-1" 
                  @click="callActionLog(proeprtyId, 7, 'Usuario hizó clic en el botón de compartir propiedad desde Asesores'); showShareModal = true"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8.6831 13.3421C8.8851 12.9381 8.9991 12.4821 8.9991 12.0001C8.9991 11.5181 8.8851 11.0621 8.6831 10.6581M8.6831 13.3421C8.38081 13.9465 7.88331 14.4311 7.2712 14.7175C6.65909 15.0038 5.96823 15.0751 5.31055 14.9198C4.65286 14.7645 4.06687 14.3917 3.64752 13.8618C3.22816 13.3319 3 12.6759 3 12.0001C3 11.3243 3.22816 10.6684 3.64752 10.1384C4.06687 9.60853 4.65286 9.23572 5.31055 9.08041C5.96823 8.92511 6.65909 8.9964 7.2712 9.28275C7.88331 9.5691 8.38081 10.0537 8.6831 10.6581M8.6831 13.3421L15.3151 16.6581M8.6831 10.6581L15.3151 7.34211M15.3151 16.6581C14.9592 17.37 14.9006 18.194 15.1523 18.9491C15.404 19.7041 15.9453 20.3282 16.6571 20.6841C17.3689 21.04 18.193 21.0986 18.948 20.8469C19.7031 20.5953 20.3272 20.054 20.6831 19.3421C21.039 18.6303 21.0976 17.8062 20.8459 17.0512C20.5942 16.2962 20.0529 15.672 19.3411 15.3161C18.9886 15.1399 18.6049 15.0348 18.2118 15.0069C17.8187 14.9789 17.424 15.0287 17.0502 15.1533C16.2951 15.405 15.671 15.9463 15.3151 16.6581ZM15.3151 7.34211C15.4913 7.69452 15.7353 8.00876 16.0329 8.26689C16.3306 8.52503 16.6762 8.722 17.05 8.84657C17.4238 8.97114 17.8185 9.02087 18.2115 8.99291C18.6045 8.96495 18.9882 8.85985 19.3406 8.68361C19.693 8.50738 20.0072 8.26346 20.2654 7.96578C20.5235 7.66811 20.7205 7.3225 20.8451 6.9487C20.9696 6.5749 21.0194 6.18022 20.9914 5.7872C20.9634 5.39418 20.8583 5.01052 20.6821 4.65811C20.3262 3.94641 19.7021 3.40524 18.9472 3.15366C18.1923 2.90208 17.3683 2.96069 16.6566 3.31661C15.9449 3.67253 15.4037 4.2966 15.1521 5.05153C14.9006 5.80646 14.9592 6.63041 15.3151 7.34211Z" class="stroke-tuin-100 group-hover:stroke-white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>

                <button
                  v-if="!property.is_associated" 
                  class="group flex items-center rounded-full border hover:bg-custom_gray border-custom_gray p-1"
                  @click="goToEdit('edit', proeprtyId)" 
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M16.732 3.73196C17.2009 3.26306 17.8369 2.99963 18.5 2.99963C19.1631 2.99963 19.7991 3.26306 20.268 3.73196C20.7369 4.20087 21.0003 4.83683 21.0003 5.49996C21.0003 6.16309 20.7369 6.79906 20.268 7.26796L18.768 8.76796L6.5 21.036H3V17.464L15.232 5.23196L16.732 3.73196Z" class="fill-white group-hover:fill-custom_gray"/>
                    <path d="M15.232 5.23196L18.768 8.76796M16.732 3.73196C17.2009 3.26306 17.8369 2.99963 18.5 2.99963C19.1631 2.99963 19.7991 3.26306 20.268 3.73196C20.7369 4.20087 21.0003 4.83683 21.0003 5.49996C21.0003 6.16309 20.7369 6.79906 20.268 7.26796L6.5 21.036H3V17.464L16.732 3.73196Z" class="stroke-custom_gray group-hover:stroke-white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button> 
              </div>
            </div>
          </div>
          <!-- Caracteristicas section -->
          <div class="flex flex-wrap mt-2 pb-8">
            <CardMovementComponent :property="property" />
            <!-- Nombre -->
            <h1 class="text-left text-xl md:text-xl font-medium md:mt-2">
              {{ property.property_name }}
            </h1>
            <!-- Dirección -->
            <p class="flex items-center text-gray-400 text-sm font-medium">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <path d="M8.00048 10.2414C7.47306 10.2414 6.95749 10.085 6.51896 9.79202C6.08043 9.49901 5.73863 9.08253 5.5368 8.59526C5.33496 8.10799 5.28216 7.57181 5.38505 7.05453C5.48794 6.53725 5.74192 6.06209 6.11486 5.68915C6.4878 5.31621 6.96295 5.06224 7.48024 4.95934C7.99752 4.85645 8.5337 4.90926 9.02097 5.11109C9.50824 5.31293 9.92471 5.65472 10.2177 6.09325C10.5107 6.53178 10.6671 7.04735 10.6671 7.57477C10.6671 8.28201 10.3862 8.96029 9.8861 9.46039C9.386 9.96049 8.70772 10.2414 8.00048 10.2414ZM8.00048 6.24144C7.73677 6.24144 7.47898 6.31964 7.25972 6.46614C7.04045 6.61265 6.86955 6.82089 6.76864 7.06453C6.66772 7.30816 6.64132 7.57625 6.69276 7.83489C6.74421 8.09353 6.8712 8.33111 7.05767 8.51758C7.24414 8.70405 7.48172 8.83104 7.74036 8.88248C7.999 8.93393 8.26709 8.90753 8.51072 8.80661C8.75436 8.70569 8.96259 8.5348 9.1091 8.31553C9.25561 8.09627 9.33381 7.83848 9.33381 7.57477C9.33381 7.22115 9.19334 6.88201 8.94329 6.63196C8.69324 6.38191 8.3541 6.24144 8.00048 6.24144Z" fill="#737373"/>
                <path d="M8.00048 15.5748C7.90205 15.5747 7.80485 15.5529 7.71586 15.5108C7.62688 15.4687 7.54831 15.4075 7.48581 15.3314L3.98914 11.0821C3.92248 11.0074 3.84648 10.9141 3.77181 10.8154L3.69181 10.7181C3.66076 10.6805 3.63393 10.6396 3.61181 10.5961C3.0627 9.79989 2.74044 8.86933 2.67953 7.90404C2.61863 6.93875 2.82136 5.97507 3.26605 5.11615C3.71073 4.25723 4.38061 3.5354 5.204 3.02793C6.02738 2.52045 6.97327 2.24644 7.94041 2.23522C8.90756 2.224 9.85955 2.476 10.6945 2.96423C11.5294 3.45247 12.2159 4.15856 12.6804 5.00694C13.1448 5.85531 13.3699 6.81403 13.3314 7.78047C13.2929 8.74691 12.9923 9.6847 12.4618 10.4934C12.44 10.5393 12.4127 10.5823 12.3805 10.6214L12.2958 10.7248C12.1766 10.8878 12.048 11.0436 11.9105 11.1914L8.51581 15.3281C8.45356 15.4048 8.37503 15.4668 8.28591 15.5094C8.19678 15.5521 8.09929 15.5744 8.00048 15.5748ZM4.78381 9.94944L4.81514 9.98744C4.88181 10.0774 4.94381 10.1488 5.00514 10.2181L8.00048 13.8581L10.9058 10.3194C11.0252 10.1909 11.1365 10.0551 11.2391 9.91277L11.2891 9.8521L11.3065 9.82477C11.7188 9.22014 11.9574 8.51396 11.9962 7.78313C12.035 7.0523 11.8726 6.32482 11.5266 5.67992C11.1806 5.03501 10.6643 4.4974 10.0339 4.1256C9.4035 3.75381 8.68319 3.56209 7.95138 3.57133C7.21958 3.58056 6.50433 3.79039 5.88352 4.17797C5.26272 4.56555 4.76014 5.11603 4.43052 5.76946C4.1009 6.42289 3.95686 7.15423 4.0141 7.88385C4.07134 8.61347 4.32766 9.3134 4.75514 9.90744C4.76581 9.92166 4.77537 9.93566 4.78381 9.94944Z" fill="#737373"/>
              </svg>
              {{ property.address }}
            </p>

            <!-- Precio -->
            <div class="text-black text-3xl mb-2 mt-4">
              <!-- Valor de venta -->
              <div class="flex flex-wrap">
              <!-- Valor de venta -->
              <div
                v-if="property.type_movement_id == 1 || property.type_movement_id == 3 || property.type_movement_id == 5"
                class="w-full md:w-1/2 text-left md:text-left mb-4"
              >
                <span class="block text-base font-normal">
                  <template v-if="property.type_movement_id === 3">Venta</template>
                  <template v-else>{{ property.property_movement }}</template>
                </span>
                <span class="block text-3xl font-bold">
                  {{ property.property_value }}
                  <span class="text-xl font-semibold">{{ property.currency_code || property.currency }}</span>
                </span>
                <div class="text-base font-normal text-gray-900" v-if="property.has_commission_sale">Comisión {{ property.commission_sale_value }} %</div>
              </div>

              <!-- Valor de renta -->
              <div
                v-if="property.type_movement_id == 2 || property.type_movement_id == 3 || property.type_movement_id == 4"
                class="w-full md:w-1/2 text-left md:text-left mb-4"
              >
                <span class="block text-base font-normal">
                  <template v-if="property.type_movement_id === 3">Renta</template>
                  <template v-else>{{ property.property_movement }}</template>
                </span>
                <span class="block text-3xl font-bold">
                  {{ property.rent_value }}
                  <span class="text-xl font-semibold">{{ property.currency_code || property.currency }}</span>
                </span>
                <div class="text-base font-normal text-gray-900" v-if="property.has_commission_rent">Comisión {{ property.commission_rent_value }} %</div>
              </div>
            </div>
            <!-- Mantenimiento -->
              <div
                v-show="property.include_maintenance == 0 && property.maintenance_value != '$0'"
                class="text-base text-black font-medium mb-2"
              >
                <span class="block font-semibold">Mantenimiento</span>
                <span class="block font-bold text-lg">
                  {{ property.maintenance_value }}
                  <span class="text-base font-semibold">{{ property.currency }}</span>
                </span>
              </div>
              <div
                v-show="!property.include_maintenance == 0"
                class="text-base text-black font-medium mb-2"
              >
                <span class="block font-semibold">Mantenimiento incluido</span>
              </div>
            </div>
            <span class="font-medium text-xl mb-6">Características</span>
            <CardCharactersComponent 
              :list="characters_list.value"
              :property="property" 
            />
          </div>
        </div>
        <!-- Tabs fijos para desktop -->
        <div class="top-0 bg-white border-b border-gray-200">
          <div class="flex flex-row w-full justify-between items-center">
            <div class="md:w-100%">
              <!--New Tabs--> 
              <div class="text-sm font-medium text-center text-gray-500">
                  <ul class="flex flex-wrap -mb-px">                    
                      <li class="me-2">
                          <a href="#" @click.prevent="setActiveTab('portales')"
                              :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600 ', activeTab === 'portales' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                          >Portales</a>
                      </li>
                      <li class="me-2">
                          <a href="#" @click.prevent="setActiveTab('estadisticas')"
                              :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600 ', activeTab === 'estadisticas' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                          >Estadísticas</a>
                      </li>
                      <li class="me-2">
                          <a href="#" @click.prevent="setActiveTab('informacion')"
                              :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600 ', activeTab === 'informacion' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                          >Información de la propiedad</a>
                      </li>
                  </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap mt-4 lg:flex-nowrap gap-4">
          <div class="w-full lg:w-2/3 bg-white relative">
            <!-- Contenido dinámico según el tab activo -->
            
            <!-- Tab de Estadísticas -->
            <div v-if="activeTab === 'estadisticas'">
              <PropertyStatsComponent :property="property" />
            </div>
            
            <!-- Tab de Portales -->
            <div v-if="activeTab === 'portales'">
              <PropertyPortalsComponent 
                :partners="partners" 
                :slug_url="slug_url" 
                :property_id="proeprtyId"
                :has_commission_sale="property.has_commission_sale"
                :has_commission_rent="property.has_commission_rent"
                :status_id="property.status_id"
                :type_movement_id="property.type_movement_id"
              />
            </div>
            
            <!-- Tab de Información de la propiedad -->
            <div v-if="activeTab === 'informacion'">
              <!-- Información de la propiedad móvil (solo para móviles) -->
              <div class="only-mob">
                <div class="space-y-2">
                  <!--Información de la propiedad section unified-->
                  <PropertyInfoComponent
                    :description="description"
                    :characters_additional="characters_additional"
                    :amenities_list="amenities_list.value"
                    :friendly_list="friendly_list.value"
                    :requirements_list="requirement_list.value"
                    :services_list="services_list.value"
                    :property="property"
                  />

                  <!-- Mapa -->
                  <div v-if="property && property.property_lt && property.property_ln" class="border-b border-gray-200">
                    <button 
                      @click="toggleAccordion('mapa')"
                      class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                    >
                      <span>Mapa</span>
                      <svg 
                        :class="['w-4 h-4 transition-transform duration-200', accordionStates.mapa ? 'rotate-0' : '']"
                        aria-hidden="true" 
                        xmlns="http://www.w3.org/2000/svg" 
                        fill="none" 
                        viewBox="0 0 10 6"
                        transform="matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)"
                      >
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                      </svg>
                    </button>
                    <div 
                      v-show="accordionStates.mapa"
                      class="p-4 border-t border-gray-200"
                    >
                      <div
                        ref="mapRefMobile"
                        style="width: 100%; height: 300px"
                      />
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Información de la propiedad desktop (solo para escritorio) -->
              <div class="only-dest">
                <PropertyInfoComponent
                  :description="description"
                  :characters_additional="characters_additional"
                  :amenities_list="amenities_list.value"
                  :friendly_list="friendly_list.value"
                  :requirements_list="requirement_list.value"
                  :services_list="services_list.value"
                  :property="property"
                />

                <!-- Mapa de ubicación  -->
                <div id="mapa" v-if="property && property.property_lt && property.property_ln" class="flex flex-wrap mt-8 bg-white mb-20">
                  <fwb-heading tag="h4" class="font-medium text-xl mb-4">
                    Mapa de ubicación
                  </fwb-heading>
                  <div
                    ref="mapRef"
                    style="width: 100%; height: 400px"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- Fin Columna izquierda -->
          <!-- Columna derecha -->

          <!-- Fin Columna derecha -->
        </div>
      </div>
      
      <!-- Modales -->
      <ShareModal
        v-if="showShareModal"
        :slug_url="slug_url"
        :property="property"
        :property-id="proeprtyId"
        :session="session"
        @close="showShareModal = false"
        @copy-link="showToast('success', 'Enlace copiado al portapapeles')"
      />
      
      <ReportPropertyModal
        v-if="showReportModal"
        :is-active="showReportModal"
        :property-id="proeprtyId"
        :property-name="property.property_name"
        :report-reasons="reportReasons"
        :agent-id="property.agent ? property.agent.id : null"
        @close="showReportModal = false"
        @success="handleReportSuccess"
      />
      <DeletePropertie
        :isVisible="showDeleteModal"
        @confirm="confirmDelete"
        @cancel="closeModal"
      />
      <RemovePropertyModal
        :isVisible="showRemoveModal"
        @confirm="confirmRemoveProperty"
        @cancel="closeRemoveModal"
      />
  </div>
</template>
  
<script setup>
// Add any script logic if needed
import { FwbHeading, } from "flowbite-vue";
import { Loader } from "@googlemaps/js-api-loader";

import { ref, computed, onMounted, nextTick } from "vue";
import axios from "axios";

import { useRoute } from "vue-router";
const route = useRoute();
import ToastAlert from '@/commond/ToastAlert.vue';

import { useStore } from "vuex";
import CardMovementComponent from "./show/CardMovementComponent.vue";
import CardCharactersComponent from "./show/CardCharactersComponent.vue";
import GalleryComponent from './GalleryComponent.vue';
import PropertyInfoComponent from './PropertyInfoComponent.vue';
import PropertyStatsComponent from './show/PropertyStatsComponent.vue';
import PropertyPortalsComponent from './show/PropertyPortalsComponent.vue';
import ShareModal from './show/ShareModal.vue';
import ReportPropertyModal from './show/ReportPropertyModal.vue';
import { useRouter } from "vue-router";
import DeletePropertie from "./Modal/DeletePropertie.vue";
import RemovePropertyModal from './Modal/RemovePropertyModal.vue';

const store = useStore();
let session = computed(() => store.getters.getUserSession);

let router = useRouter();
let loader = ref(false);
let proeprtyId = route.params.property_id;
let slug_url = ref({});
let property = ref({});
let pictures = ref([]);
let description = ref("<p></p>");
let characters_additional = ref("<p></p>");
let characters_list = ref([]);
let amenities_list = ref([]);
let friendly_list = ref([]);
let requirement_list = ref([]);
let services_list = ref([]);
let partners = ref([]);
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");
const activeTab = ref('portales');

// Estados para los modales
const showReportModal = ref(false);
const showShareModal = ref(false);

// Variables para el select de estado
const selectedStatus = ref("");
const statusOptions = ref([
  { value: 1, name: "Activar" },
  { value: 2, name: "Desactivar" }
]);

// Estados para los acordeones móviles
const accordionStates = ref({
  caracteristicas: false,
  descripcion: false,
  otras_caracteristicas: false,
  amenidades: false,
  friendly: false,
  requisitos: false,
  servicios: false,
  video: false,
  mapa: false
});

const selectedUserId = ref(null);
const showDeleteModal = ref(false);

const propertyIdToRemove = ref(null);
const showRemoveModal = ref(false);

function openDeleteModal(propertyId) {
  selectedUserId.value = propertyId;
  showDeleteModal.value = true;
}

// Referencia para el mapa móvil
const mapRefMobile = ref(null);

// Motivos de reporte precargados
const reportReasons = ref([]);

async function fetchReportReasons() {
  try {
    if (!session.value || !session.value.token_api) {
      console.error('No hay sesión o token_api');
      return;
    }
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
        'Content-Type': 'application/json'
      },
    };
    let link = `${process.env.VUE_APP_API_BASE_URL}/catalogue-reports`;
    const response = await axios.get(link, options);
    if (response.status === 200) {
      let motivos = response.data.resp;
      reportReasons.value = motivos.map(motivo => ({
        id: motivo.id,
        name: motivo.name,
        description: motivo.description
      }));
      //console.log('Motivos precargados:', reportReasons.value);
    }
  } catch (error) {
    console.error("Error fetching report reasons:", error);
  }
}

async function getDetail() {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let link = `${process.env.VUE_APP_API_BASE_URL}/broker/detail/property/${session.value.id}/${proeprtyId}`;

    const response = await axios.get(link, options);

    //console.log("✅ Respuesta completa de partners:", response.data.resp.partners);
    if (response.status == 200) {
      property.value = response.data.info;
      slug_url.value = response.data.resp.general.slug_url;
      characters_list.value = response.data.resp.character_list || [];
      amenities_list.value = response.data.resp.amenities_list || [];
      friendly_list.value = response.data.resp.friendly_list || [];
      requirement_list.value = response.data.resp.requirement_list || [];
      services_list.value = response.data.resp.services_list || [];
      
      // Establecer el estado seleccionado basado en el status_id de la propiedad
      selectedStatus.value = property.value.status_id || 1;
      
      loader.value = false;

      pictures.value = response.data.resp.images;

      description.value = property.value.property_description;
      characters_additional.value = property.value.characteristics;
      partners.value = response.data.resp.partners;
      //callActionLog(proeprtyId, 1, "Asesor visito la propiedad");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
async function callActionLog(property_id, type_action, detail){

let link = `${process.env.VUE_APP_API_BASE_URL}/event/add_log`;
let param_analytics = {
      "property_id":          property_id,
      "user_id":              session.value.id,
      "activity_id":          type_action,
      "description":          detail,          
}
console.log(param_analytics)

let options = {
  headers: {
    "Content-Type": "application/json"
  },
};

try {
  const response = await axios.post(link, param_analytics, options);

  if (response.status == 401) {
    //console.log("Hay que sacarlo de la sesion ");
  }

  if (response.status == 200) {
    console.log(response);
  }
  
} catch (error) {
  console.error("Error fetching data:", error);
}

}
//let loader_map;
const apiKey = "AIzaSyDh_2CwOWAcS258EwjQsctRq9ypVZfHAZw";
const mapRef = ref(null);

async function goToEdit(state, property_id) {
  router.push({ name: "propertyFormEdit", params: { id: property_id } });
}

const confirmDelete = async () => {
  
  // Activar loader instantáneamente y cerrar modal
  loader.value = true;
  showDeleteModal.value = false;
  
  let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${selectedUserId.value}/change_status`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  // Enviar el status como 3 (eliminado)
  let param_post = { "status": 3 };

  try {
    const response = await axios.put(url_cnn, param_post, options);
    
    if (response.status === 200) {
      console.log("Propiedad eliminada en la base de datos local.");
      
      // 🔄 Llamar a la función para eliminar en propiedades.com
      await deleteFromPropiedades(selectedUserId.value);
      // 🔄 Llamar a la función para eliminar en Easy Broker
      await deleteFromEasyBroker(selectedUserId.value);
      
      // Mostrar mensaje de éxito y redirigir
      showToast('success', 'Propiedad eliminada correctamente');
      
      // Redirigir a la página de propiedades después de un breve delay
      setTimeout(() => {
        router.push({ name: "propertyList" });
      }, 3000);
    }
  } catch (error) {
    console.log("[ERROR]", error.response);
    showToast('error', 'Error al eliminar la propiedad');
    loader.value = false;
  }
};
async function deleteFromPropiedades(propertyId) {
  let url = `${process.env.VUE_APP_API_BASE_URL}/propertiesComDelete/${propertyId}`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.delete(url, options);
    
    if (response.status === 200) {
      console.log("Propiedad eliminada en propiedades.com");
    } else {
      console.log("Error al eliminar en propiedades.com", response.status);
    }
  } catch (error) {
    console.error("Error al eliminar en propiedades.com:", error);
  }
}
async function deleteFromEasyBroker(propertyId) {
  let url = `${process.env.VUE_APP_API_BASE_URL}/delete-easybroker/${propertyId}`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, options);
    
    if (response.status === 200) {
      console.log("Propiedad eliminada en Easy Broker");
    } else {
      console.log("Error al eliminar en pEasy Broker", response.status);
    }
  } catch (error) {
    console.error("Error al eliminar en Easy Broker:", error);
  }
}
const closeModal = () => {
  showDeleteModal.value = false; // Cierra el modal
};

// Función para cambiar el estado de la propiedad
async function changePropertyStatus() {
  if (!selectedStatus.value) return;
  
  let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${proeprtyId}/change_status`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  let param_post = { "status": selectedStatus.value };

  try {
    loader.value = true; // Activar loading durante el proceso
    
    const response = await axios.put(url_cnn, param_post, options);
    
    if (response.status === 200) {
      // ✅ Actualizar el estado local de la propiedad
      property.value.status_id = selectedStatus.value;
      
      // 🔄 Sincronización con plataformas externas según el nuevo estado
      await handleExternalPlatformSync(selectedStatus.value);
      
      const statusText = selectedStatus.value === 1 ? 'activada' : 'desactivada';
      showToast('success', `Propiedad ${statusText} correctamente`);
    }
  } catch (error) {
    console.log("[ERROR]", error.response);
    showToast('error', 'Error al cambiar el estado de la propiedad');
  } finally {
    loader.value = false; // Desactivar loading
  }
}

// Nueva función para manejar la sincronización con plataformas externas
async function handleExternalPlatformSync(newStatus) {
  // Obtener partners desde la propiedad actual
  const easyBrokerPartner = partners.value?.find(p => p.partner === 'EasyBroker');
  const propiedadesComPartner = partners.value?.find(p => p.partner === 'PropiedadesCom');
  
  if (newStatus === 1) {
    // 🟢 ACTIVAR - Sincronizar con plataformas
    console.log("🟢 Activando propiedad - sincronizando con plataformas...");
    
    // EasyBroker Logic
    if (!easyBrokerPartner || (easyBrokerPartner.status !== 'active' && easyBrokerPartner.status !== 'delete')) {
      await syncWithEasyBroker(proeprtyId);
    } else if (easyBrokerPartner.status === 'delete') {
      await updateWithEasyBroker(proeprtyId);
    } else {
      console.log("✅ EasyBroker ya activo, no se hace nada.");
    }

    // PropiedadesCom Logic
    if (!propiedadesComPartner || propiedadesComPartner.status !== 'active') {
      await syncWithPropiedades(proeprtyId);
    } else {
      console.log("✅ PropiedadesCom ya activo, no se sincroniza.");
    }
    
  } else if (newStatus === 2) {
    // 🔴 DESACTIVAR - Eliminar de plataformas activas
    console.log("🔴 Desactivando propiedad - eliminando de plataformas...");
    
    // Solo eliminar de EasyBroker si está activo
    if (easyBrokerPartner && easyBrokerPartner.status === 'active') {
      await deleteFromEasyBroker(proeprtyId);
    } else {
      console.log("⏹ No se elimina de EasyBroker porque no está activo o no existe.");
    }
    
    // Para PropiedadesCom, podrías decidir si también eliminarlo o solo dejarlo
    // En el ejemplo del FormComponent no lo eliminan, solo EasyBroker
  }
}

// Funciones de sincronización (adaptadas del ListPropertiesComponent)
async function syncWithPropiedades(propertyId) {
  let syncUrl = `${process.env.VUE_APP_API_BASE_URL}/propertiesComUpdate/${propertyId}`;

  let syncOptions = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const syncResponse = await axios.put(syncUrl, {}, syncOptions);
    if (syncResponse.status === 200) {
      console.log("✅ Sincronización con propiedades.com completada");
      showToast('success', 'Sincronizado con PropiedadesCom');
    } else {
      console.log("⚠️ Error en sincronización: ", syncResponse.status);
    }
  } catch (error) {
    console.error("❌ Error al sincronizar con propiedades.com:", error);
  }
}

async function syncWithEasyBroker(propertyId) {
  let url_sync = `${process.env.VUE_APP_API_BASE_URL}/enviar-easybroker/${propertyId}`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url_sync, {}, options);

    if (
      response.status === 200 &&
      Array.isArray(response.data) &&
      response.data[0]?.status === "success"
    ) {
      console.log("✅ Propiedad creada en EasyBroker");
      showToast('success', 'Sincronizado con EasyBroker');
      
      // Actualizar partners localmente
      await refreshPropertyData();
    } else {
      console.warn("⚠️ Error en respuesta de EasyBroker:", response.data);
    }
  } catch (error) {
    console.error("❌ Error al sincronizar con EasyBroker:", error.response);
    showToast('error', 'Error al sincronizar con EasyBroker');
  }
}

async function updateWithEasyBroker(propertyId) {
  let url_sync = `${process.env.VUE_APP_API_BASE_URL}/editar-easybroker/${propertyId}`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url_sync, {}, options);

    if (
      response.status === 200 &&
      Array.isArray(response.data) &&
      response.data[0]?.status === "success"
    ) {
      console.log("✅ Propiedad reactivada en EasyBroker");
      showToast('success', 'Reactivado en EasyBroker');
      
      // Actualizar partners localmente
      await refreshPropertyData();
    } else {
      console.warn("⚠️ Error en respuesta de EasyBroker:", response.data);
    }
  } catch (error) {
    console.error("❌ Error al reactivar en EasyBroker:", error.response);
    showToast('error', 'Error al reactivar en EasyBroker');
  }
}

// Función para refrescar datos de la propiedad (incluyendo partners)
async function refreshPropertyData() {
  try {
    // Refrescar solo los partners sin recargar toda la página
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/detail/property/${session.value.id}/${proeprtyId}`,
      {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      }
    );
    
    if (response.status === 200) {
      // Actualizar solo los partners
      partners.value = response.data.resp.partners || [];
    }
  } catch (error) {
    console.error("Error al refrescar datos de la propiedad:", error);
  }
}

function askRemoveProperty(property_id) {
  propertyIdToRemove.value = property_id;
  showRemoveModal.value = true;
}
function closeRemoveModal() {
  showRemoveModal.value = false;
  propertyIdToRemove.value = null;
}
async function confirmRemoveProperty() {
  if (propertyIdToRemove.value) {
    removeProperty(propertyIdToRemove.value);
  }
  showRemoveModal.value = false;
  propertyIdToRemove.value = null;
}

async function removeProperty(property_id) {
  if (!session.value.id) {
    router.push({ name: "login" });
    return;
  }
  
  const post_params = {
    property_id: property_id,
    is_owner: false,
  };

  const url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${session.value.id}/remove_to_profile`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, post_params, options);

    if (response.status === 200) {
      console.log("✅ Propiedad eliminada:", response.data.message);
      showToast('success', 'Propiedad removida correctamente');
      
      // Esperar 3 segundos antes de navegar para que el usuario vea el toast
      setTimeout(() => {
        router.push({ name: "propertyList" });
      }, 3000);
    } else {
      console.log("⚠️ Hubo un error al eliminar la propiedad");
    }
  } catch (error) {
    console.log("❌ Error al eliminar la propiedad:", error);
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
  }
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

async function showToast(type, message){
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast()
  }, 3000);
}

function handleReportSuccess(message) {
  showToast('success', message);
  callActionLog(proeprtyId, 8, 'Usuario reportó la propiedad');
}

onMounted(async () => {
  loader.value = true;
  await getDetail();
  await fetchReportReasons();
  
  // Inicializar el estado seleccionado basado en el status_id de la propiedad
  //selectedStatus.value = property.value.status_id || 1;
  
  // Remover la inicialización del mapa de aquí ya que se hace cuando se cambia al tab
  loader.value = false;
});

// Función para inicializar el mapa de escritorio
async function initDesktopMap() {
  if (!mapRef.value || !property.value.property_lt || !property.value.property_ln) return;
  
  try {
    const loader_map = new Loader({
      apiKey: apiKey,
      libraries: ["places"],
    });

    const google = await loader_map.load();
    
    const map = new google.maps.Map(mapRef.value, {
      center: {
        lat: property.value.property_lt,
        lng: property.value.property_ln,
      },
      zoom: 15,
    });

    new google.maps.Marker({
      position: {
        lat: property.value.property_lt,
        lng: property.value.property_ln,
      },
      map,
      title: `${property.value.property_name}`,
      icon: {
        url: "https://tuin.ai/imgs/PinTuin.svg",
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(25, 50),
      },
    });
  } catch (error) {
    console.error("Error al cargar Google Maps escritorio:", error);
  }
}

// Función para cambiar entre tabs
function setActiveTab(tabName) {
  activeTab.value = tabName;
  
  // Si se cambia al tab de información, inicializar el mapa de escritorio
  if (tabName === 'informacion') {
    nextTick(() => {
      initDesktopMap();
    });
  }
}

// Función para alternar el estado de los acordeones
function toggleAccordion(sectionId) {
  // Si el acordeón ya está abierto, lo cerramos
  if (accordionStates.value[sectionId]) {
    accordionStates.value[sectionId] = false;
  } else {
    // Cerramos todos los acordeones primero
    Object.keys(accordionStates.value).forEach(key => {
      accordionStates.value[key] = false;
    });
    // Abrimos solo el acordeón seleccionado
    accordionStates.value[sectionId] = true;
    
    // Si se abre el mapa, inicializar el mapa móvil
    if (sectionId === 'mapa' && mapRefMobile.value) {
      nextTick(() => {
        initMobileMap();
      });
    }
  }
}

// Función para inicializar el mapa móvil
async function initMobileMap() {
  if (!mapRefMobile.value || !property.value.property_lt || !property.value.property_ln) return;
  
  try {
    const loader_map = new Loader({
      apiKey: apiKey,
      libraries: ["places"],
    });

    const google = await loader_map.load();
    
    const map = new google.maps.Map(mapRefMobile.value, {
      center: {
        lat: property.value.property_lt,
        lng: property.value.property_ln,
      },
      zoom: 15,
    });

    new google.maps.Marker({
      position: {
        lat: property.value.property_lt,
        lng: property.value.property_ln,
      },
      map,
      title: `${property.value.property_name}`,
      icon: {
        url: "https://tuin.ai/imgs/PinTuin.svg",
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(25, 50),
      },
    });
  } catch (error) {
    console.error("Error al cargar Google Maps móvil:", error);
  }
}
</script>
  
<style>
/* Add custom styles if required */
#propiedad,
#caracteristicas,
#descripcion,
#additional_characteristics,
#amenidades,
#friendly,
#requisitos,
#servicios,
#video,
#mapa {
  scroll-margin-top: 70px;
}

@media (max-width: 1224px) {
  .only-dest { display: none !important; }
  .only-mob { display: block !important; }
}
@media (min-width: 1225px) {
  .only-dest { display: block !important; }
  .only-mob { display: none !important; }
}
</style>
  